/*********************** Custom JS for Boost AI Search & Discovery  ************************/
const updateProductItem = (componentRegistry) => {
    
    componentRegistry.useComponentPlugin('ProductItem', {
      
        name: 'Add logo to product img',
        enabled: true,
        apply: () => ({
          afterRender(element){
            
            let productData = element.getParams().props.product;
            let productItem = document.querySelector('[data-product-id="'+ productData.id +'"]');

            // console.log(productData);

            fetch('/products/'+productData.handle+'?view=color-swatch').then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok ' + response.statusText);
                }
                return response.text(); // Convert response to JSON
            })
            .then(resData => {
                if(!productItem.querySelector('.swatch-wrapper')){
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(resData, 'text/html');
                    if(doc.querySelector(`#color-swatch-container`)){
                        const divContent = doc.querySelector(`#color-swatch-container`).innerHTML;
                        productItem.querySelectorAll('.boost-sd__product-link')[1].insertAdjacentHTML('afterend', '<div class="swatch-wrapper">'+divContent+'</div>');
                    }
                }
                
            })
            .catch(error => {
                console.error('There has been a problem with your fetch operation:', error);
            });

            
            
          }
        }),
        
      });
    }
  
  
  window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([updateProductItem]);